export enum BuilderApi {
  Key = "6b4f007b3a6543c88ff074be5bd6d985",
}
